module.exports = __webpack_public_path__ + "static/img/check6.d42eef3c.jpg";